module.exports = __webpack_public_path__ + "media/images/expert-slide3-thumb-8280a76a994ece470b570a6ee97cf3206cf99ccf46c6fd46113c1f8703465522.jpg";